import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Impressum, Datenschutz } from "@/components/site/Legal";
import { Agb } from "@/components/site/Agb";
import { usePageMeta } from "@/lib/usePageMeta";

const PAGES = {
  impressum: { title: "Impressum", Comp: Impressum, desc: "Impressum von Maison Princess, Beauty- und Wellnessstudio in Bensheim." },
  datenschutz: { title: "Datenschutzerklärung", Comp: Datenschutz, desc: "Datenschutzerklärung von Maison Princess in Bensheim." },
  agb: { title: "AGB – Allgemeine Geschäftsbedingungen", Comp: Agb, desc: "Allgemeine Geschäftsbedingungen von Maison Princess in Bensheim: Termine, Ausfallhonorar, Zahlung." },
};

export default function LegalPage({ kind }) {
  const { title, Comp, desc } = PAGES[kind];
  usePageMeta(`${title} | Maison Princess`, desc, `/${kind}`);
  return (
    <div data-testid={`legal-page-${kind}`} className="mx-auto max-w-3xl px-5 pb-24 pt-28 sm:px-8 sm:pt-36">
      <Link to="/" data-testid="legal-back-link" className="inline-flex items-center gap-2 text-sm text-gold-deep">
        <ArrowLeft className="h-4 w-4" /> <span className="link-underline">Zur Startseite</span>
      </Link>
      <h1 className="mt-8 font-serif text-4xl leading-tight text-ink sm:text-6xl">{title}</h1>
      <div className="mt-6 rounded-[28px] border border-gold/25 bg-paper p-6 sm:p-10">
        <Comp />
      </div>
    </div>
  );
}
